var map = {
	"./de_DE.json": 6543,
	"./en_CA.json": 7313,
	"./en_GB.json": 9541,
	"./fr_CA.json": 3152,
	"./it_IT.json": 2634,
	"./pl_PL.json": 2262,
	"./sk_SK.json": 4670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;